import { render, staticRenderFns } from "./field-dropdown.vue?vue&type=template&id=5c3e219e&scoped=true"
import script from "./field-dropdown.vue?vue&type=script&lang=js"
export * from "./field-dropdown.vue?vue&type=script&lang=js"
import style0 from "./field-dropdown.vue?vue&type=style&index=0&id=5c3e219e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e219e",
  null
  
)

export default component.exports